import { render, staticRenderFns } from "./c-modal@.vue?vue&type=template&id=1027dd5e&"
import script from "./c-modal@.vue?vue&type=script&lang=ts&"
export * from "./c-modal@.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports